import { Route, Routes, Outlet } from "react-router-dom";
import Dashboard from "../pages/admin/Dashboard";
import AdminLayout from "../layouts/AdminLayout";
import Users from "../pages/admin/Users";
import UserDetail from "../pages/admin/UserDetail";
import AffiliateDetail from "../pages/admin/AffiliateDetail";
import AddCategory from "../pages/admin/AddCategory";
import Categories from "../pages/admin/Categories";
import Lessons from "../pages/admin/Lessons";
import Questions from "../pages/admin/Questions";
import AddLesson from "../pages/admin/AddLesson";
import AddQuestion from "../pages/admin/AddQuestion";
import EditQuestion from "../pages/admin/EditQuestion";
import EditCategory from "../pages/admin/EditCategory";
import EditLesson from "../pages/admin/EditLesson";
import EditCard from "../pages/admin/EditCard";
import EditSlide from "../pages/admin/EditSlide";
import Pricing from "../pages/admin/Pricing";
import ActCodes from "../pages/admin/ActCodes";
import ACodes from "../pages/admin/ACodes";
import AddCoupon from "../pages/admin/AddCoupon";
import Coupons from "../pages/admin/Coupons";
import AddPage from "../pages/admin/AddPage";
import Slides from "../pages/admin/Slides";
import AddSlides from "../pages/admin/AddSlides";
import ViewPages from "../pages/admin/ViewPages";
import GeneralSettings from "../pages/admin/Settings";
import AdminShield from "../components/AdminShield";
import Logout from "../components/AdminLogout";
import AddCard from "../pages/admin/AddCard";
import Cards from "../pages/admin/Cards";
import Orders from "../pages/admin/Orders";
import AddCustomerReviews from "../pages/admin/AddCustomerReviews";
import CustomerReviews from "../pages/admin/CustomerReviews";
import Distributors from "../pages/admin/Distributors";
import Applications from "../pages/admin/affiliate/Applications";
import AffiliateGeneral from "../pages/admin/affiliate/General";
import Affiliates from "../pages/admin/affiliate/Affiliates";

export function AdminRoutes() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route
          path="users"
          element={
            <AdminShield allowedRoles={["admin", "superadmin"]}>
              <Outlet />
            </AdminShield>
          }
        >
          <Route index element={<Users />} />
          <Route path=":id" element={<UserDetail />} />
        </Route>
        <Route path="/xl-admin/user/:id" element={<UserDetail />} />
        <Route
          path="affiliates"
          element={
            <AdminShield allowedRoles={["superadmin"]}>
              <Outlet />
            </AdminShield>
          }
        >
          <Route index element={<Affiliates />} />
          <Route path=":id" element={<AffiliateDetail />} />
        </Route>
        <Route path="add-category" element={<AddCategory />} />
        <Route path="categories" element={<Categories />} />
        <Route path="add-lesson" element={<AddLesson />} />
        <Route path="add-question" element={<AddQuestion />} />
        <Route path="lessons" element={<Lessons />} />
        <Route path="questions" element={<Questions />} />
        <Route path="add-page" element={<AddPage />} />
        <Route path="pages" element={<ViewPages />} />
        <Route path="edit-question" element={<EditQuestion />} />
        <Route path="edit-lesson" element={<EditLesson />} />
        <Route path="edit-category" element={<EditCategory />} />
        <Route path="edit-card" element={<EditCard />} />
        <Route path="edit-slide" element={<EditSlide />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="slides" element={<Slides />} />
        <Route path="add-slides" element={<AddSlides />} />
        <Route path="add-card" element={<AddCard />} />
        <Route path="add-coupon" element={<AddCoupon />} />
        <Route path="orders" element={<Orders />} />
        <Route path="cards" element={<Cards />} />
        <Route path="add-customer-reviews" element={<AddCustomerReviews />} />
        <Route path="customer-reviews" element={<CustomerReviews />} />
        <Route path="logout" element={<Logout />} />
        <Route
          path="options-general"
          element={
            <AdminShield allowedRoles={["admin", "superadmin"]}>
              <GeneralSettings />
            </AdminShield>
          }
        />
        <Route
          path="distributors"
          element={
            <AdminShield allowedRoles={["superadmin"]}>
              <Distributors />
            </AdminShield>
          }
        />
        <Route
          path="affiliate-general"
          element={
            <AdminShield allowedRoles={["superadmin"]}>
              <AffiliateGeneral />
            </AdminShield>
          }
        />
        <Route
          path="applications"
          element={
            <AdminShield allowedRoles={["superadmin"]}>
              <Applications />
            </AdminShield>
          }
        />
        <Route
          path="affiliates"
          element={
            <AdminShield allowedRoles={["superadmin"]}>
              <Affiliates />
            </AdminShield>
          }
        />
        <Route
          path="coupons"
          element={
            <AdminShield allowedRoles={["superadmin"]}>
              <Coupons />
            </AdminShield>
          }
        />
        <Route
          path="actcodes"
          element={
            <AdminShield allowedRoles={["superadmin"]}>
              <ActCodes />
            </AdminShield>
          }
        />
        <Route
          path="acodes"
          element={
            <AdminShield allowedRoles={["superadmin"]}>
              <ACodes />
            </AdminShield>
          }
        />
      </Route>
    </Routes>
  );
}
